export default __webpack_public_path__ + "static/media/report-copy.9f6bdfb4.svg";